import { createReducer, on } from '@ngrx/store';
import { CommodityTableState } from './commodity-table.state';
import {
    commodityTableChangePage,
    commodityTableChangeQuery, commodityTableDelete, commodityTableDeleteFailure, commodityTableDeleteSuccess,
    commodityTableFailure, commodityTableMasterToggle,
    commodityTableRequest, commodityTableSetSelection, commodityTableSort,
    commodityTableSuccess, commodityTableToggle
} from './commodity-table.actions';

const initialState: CommodityTableState = {
    query: {
        sortColumn: 'description',
        sortDescending: false,
        pageNumber: 1,
        itemsPerPage: 25,
        description: null
    },
    page: [],
    totalCount: null,
    filteredCount: null,
    busy: false,
    error: false,
    selection: [],
    deleting: []
};

const reducer = createReducer(
    initialState,
    on(commodityTableRequest, (state) => ({
        ...state,
        busy: true,
        error: false
    })),
    on(commodityTableSuccess, (state, { totalCount, page }) => ({
        ...state,
        busy: false,
        page,
        totalCount,
        error: false
    })),
    on(commodityTableFailure, (state) => ({
        ...state,
        busy: false,
        error: true,
    })),
    on(commodityTableRequest, (state) => ({
        ...state,
        busy: true,
        error: false
    })),
    on(commodityTableChangePage, (state, { pageNumber, itemsPerPage }) => ({
        ...state,
        selection: [],
        query: { ...state.query, pageNumber, itemsPerPage }
    })),
    on(commodityTableChangeQuery, (state, { query }) => ({
        ...state,
        query
    })),
    on(commodityTableSort, (state, { id, descending }) => ({
        ...state,
        query: { ...state.query, sortColumn: id, sortDescending: descending }
    })),
    on(commodityTableSetSelection, (state, { selection }) => ({
        ...state,
        selection
    })),
    on(commodityTableToggle, (state, { id }) => ({
        ...state,
        selection: state.selection.indexOf(id) === -1 ? [ ...state.selection, id ] : state.selection.filter((sid) => sid !== id)
    })),
    on(commodityTableMasterToggle, (state) => ({
        ...state,
        selection: state.selection.length === 0 ? state.page.map(h => h.id) : []
    })),
    on(commodityTableDelete, (state) => ({
        ...state,
        deleting: [ ...state.deleting, ...state.selection ],
        selection: []
    })),
    on(commodityTableDeleteSuccess, (state) => ({
        ...state,
        deleting: []
    })),
    on(commodityTableDeleteFailure, (state) => ({
        ...state,
        deleting: []
    }))
);

export function commodityTableReducer(state: CommodityTableState | undefined, action: any): any {
    return reducer(state, action);
}
